import React, { Component } from "react";
import { connect } from "react-redux";
import HireButton from "../../Common/Hire";
import SendEmail from "../../Common/SendEmail";
import QuotationTitle from "../../Common/Quotation/Title";
import QuotationPrice from "../../Common/Quotation/Price";
import PriceLines from "../../Common/Quotation/PriceLines"
import Loader from '../../Common/Loader';
import ErrorMessage from '../../Common/ErrorMessage';
import { client, pyme } from "../../../operations";
import { numberWithDots } from '../../../helpers';
import { 
  setInnerPagesList,
  setStepInnerPage,
} from '../../../actions';


const setPrefixOrSuffix = (content) => {
  return content.map(item => {
    let copy = {...item};
    if(copy.idCobertura == 9 && copy.capital <= 100)
      copy.capital = copy.capital + " %";
    else 
      copy.capital = "USD " + numberWithDots(copy.capital);
    return copy;
  });
};

class Quotation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: true,
    };
    this.priceContent = this.priceContent.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { stepInnerPage, setInnerPagesList } = this.props;
    if(!stepInnerPage || stepInnerPage.name !== 'sendEmail')
      setInnerPagesList([
        { name: 'quotation', back: '' },
        { name: 'sendEmail', back: '', backButton: false }
      ]);
  }

  priceContent() {
    const { coveragePlan, coveragePlans, coverageModule, coverageModules } = this.props;
    let content = coverageModules.find(p => p.codigoModulo == coverageModule).coberturas;
    const { valor } = coveragePlans.find(plan => plan.clave == coveragePlan);
    const amount = valor.slice(valor.indexOf(" USD ") + 5, valor.length);
    content = [{idCobertura: 0, descripcion: "Robo", capital: amount}].concat(content);
    return(<PriceLines labelName='descripcion' valueName='capital' linePadding='thin' content={setPrefixOrSuffix([...content])}/>);
  }

  render() {
    
    const { 
      stepInnerPage, loading, 
      quoteId, sendQuoteByEmail, 
      quoter, errorMessage,
      setStepInnerPage, getQuotation
    } = this.props;
    
    switch (stepInnerPage.name) {
      case 'quotation':
        return (<div>
                  { loading ? 
                      <Loader /> :
                      quoteId > 0 ?
                        <div>
                          <QuotationTitle />
                          <QuotationPrice
                            currency='USD'
                            priceContent={this.priceContent} 
                          />
                          <HireButton onThinkClick={() => {
                            setStepInnerPage('sendEmail');
                            sendQuoteByEmail(quoter);
                          }}/>
                        </div> : errorMessage ?
                        <ErrorMessage 
                          errorText='Tuvimos un inconveniente con la cotización'
                          tryAgainText='Volver a cotizar'
                          tryAgainAction={getQuotation}
                        /> : null
                  }
                </div>);
      case 'sendEmail':
        return <SendEmail />;
    };
    return <div/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    errorMessage: state.quotation.errorMessage,
    stepInnerPage: state.steps.stepInnerPage,
    
    quoter: state.options.quoter,
    coveragePlan: state.pyme.coveragePlan,
    coveragePlans: state.pyme.coveragePlans,
    coverageModule: state.pyme.coverageModule,
    coverageModules: state.pyme.coverageModules,

    quoteId: state.quotation.quoteId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    getQuotation: () => {
      dispatch(pyme.getQuotation());
    },
    sendQuoteByEmail: (quoter) => {
      dispatch(client.sendQuoteByEmail(quoter));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotation);